import { useContext } from 'react';
import SupabaseAuthContext, { SupabaseAuthContextType } from './SupabaseAuthContext';

function useSupabaseAuth(): SupabaseAuthContextType {
	return useContext(SupabaseAuthContext);
}

export default useSupabaseAuth;
